import { ASYNC_BOOLEAN } from 'data/types/progress.types';
import { sendMessageToPlugins } from './chromeExtensionUtils';

const storageKey = 'is_plugin_installed';

const checkChromeExtension = async () => {
  let isInstalled = ASYNC_BOOLEAN.LOADING;

  if (window.chrome?.runtime?.sendMessage) {
    let timer;

    const checkPlugin = sendMessageToPlugins({ message: 'version' })
      .then((results) => {
        // Handle both single result and array of results
        let responseArray;
        if (Array.isArray(results)) {
          // If it's an array, it could be either Promise.allSettled results or direct responses
          if (results.length > 0 && results[0] && typeof results[0] === 'object' && 'status' in results[0]) {
            // These are Promise.allSettled results
            responseArray = results.filter((result) => result.status === 'fulfilled').map((result) => result.value);
          } else {
            // These are direct responses
            responseArray = results;
          }
        } else {
          responseArray = [results];
        }

        const installed = responseArray.some((result) => !!result?.version);
        return installed;
      })
      .catch(() => {
        console.log('Something went wrong [plugin checker]');
        return ASYNC_BOOLEAN.ERROR;
      });

    const setPluginNotInstalled = new Promise((resolve) => {
      timer = setTimeout(() => {
        resolve(ASYNC_BOOLEAN.FALSE);
      }, 5000);
    });

    isInstalled = await Promise.race([checkPlugin, setPluginNotInstalled]);
    clearTimeout(timer);
  } else {
    isInstalled = ASYNC_BOOLEAN.ERROR;
    console.log("Browser isn't Chrome or chrome.runtime.sendMessage not available");
  }

  if (!localStorage.getItem(storageKey) && isInstalled === ASYNC_BOOLEAN.TRUE) {
    localStorage.setItem(storageKey, isInstalled);
  }

  return isInstalled;
};

export default checkChromeExtension;
